import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { featuredManga, popularMangaList, categories } from '@/mocks/manga';

function HomeSchemaOrg() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '古古漫画网',
        url: 'http://sylbdj.com/',
        description: '古古漫画网 - 提供终末的女武神等热门漫画在线免费阅读服务',
        sameAs: ['http://sylbdj.com/'],
      },
      {
        '@type': 'WebSite',
        name: '古古漫画网',
        url: 'http://sylbdj.com/',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'http://sylbdj.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '古古漫画网 - 首页',
        url: 'http://sylbdj.com/',
        description: '古古漫画网为您提供终末的女武神漫画在线免费阅读服务，简洁界面快速加载，让您轻松追更最新章节，不错过任何精彩剧情。',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'http://sylbdj.com/' },
          ],
        },
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export default function Home() {
  return (
    <>
      <HomeSchemaOrg />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section
          className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden"
          aria-label="首页横幅"
        >
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Epic%20manga%20style%20illustration%20of%20mythological%20gods%20and%20human%20warriors%20in%20dramatic%20battle%2C%20dynamic%20composition%20with%20warm%20crimson%20red%20and%20deep%20gold%20tones%2C%20dark%20atmospheric%20background%20with%20striking%20silhouettes%2C%20action%20lines%20and%20energy%20effects%2C%20Japanese%20comic%20art%20style%2C%20stylized%20and%20artistic%20rendering%2C%20dramatic%20lighting%20with%20glowing%20accents%2C%20professional%20website%20hero%20banner%20quality&width=1600&height=600&seq=hero-valkyrie-home&orientation=landscape"
              alt="终末的女武神漫画 - 古古漫画网在线免费阅读"
              title="终末的女武神漫画在线免费阅读"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />

          <div className="relative z-10 w-full flex flex-col items-center text-center px-4">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              终末的女武神
            </h1>
            <p className="font-heading text-xl md:text-2xl text-white/80 mt-4 italic">
              在线免费阅读
            </p>
            <p className="text-sm md:text-base text-white/60 mt-6 max-w-xl">
              简洁界面快速加载，让您轻松追更最新章节，不错过任何精彩剧情
            </p>
            <Link
              to="/manga/shuumatsu-no-valkyrie"
              className="whitespace-nowrap mt-8 px-8 py-3 bg-white text-foreground-900 font-medium text-sm rounded-md hover:bg-background-100 transition-colors cursor-pointer"
            >
              开始阅读
            </Link>
          </div>
        </section>

        {/* Latest Updates Section */}
        <section className="bg-background-900 py-14 md:py-20" aria-label="最新章节">
          <div className="w-full px-4 md:px-6">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
              <span className="whitespace-nowrap px-4 py-1 border border-background-300/30 text-xs text-background-200 rounded-full w-fit">
                最新章节
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight md:text-right">
                热门漫画 · 实时追更
              </h2>
            </div>

            <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide">
              {popularMangaList.slice(0, 6).map((manga) => (
                <Link
                  key={manga.id}
                  to={`/manga/${manga.id}`}
                  className="flex-shrink-0 w-[200px] md:w-[240px] group cursor-pointer"
                >
                  <div className="aspect-[3/4] rounded-lg overflow-hidden bg-background-800">
                    <img
                      src={manga.coverImage}
                      alt={`${manga.title}漫画`}
                      title={`${manga.title}漫画在线免费阅读`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>
                  <div className="mt-3">
                    <h3 className="font-heading text-sm font-semibold text-background-100 truncate">
                      {manga.title}
                    </h3>
                    <p className="text-xs text-background-400/70 mt-1">
                      {manga.latestChapter.title} · {manga.latestChapter.updateDate}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Manga Hero Card */}
        <section className="bg-background-50 py-14 md:py-20" aria-label="本期推荐">
          <div className="w-full px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
              <div className="lg:w-1/3 flex-shrink-0">
                <div className="aspect-[3/4] rounded-lg overflow-hidden max-w-[280px] mx-auto lg:max-w-none">
                  <img
                    src={featuredManga.coverImage}
                    alt={`${featuredManga.title}漫画封面`}
                    title={`${featuredManga.title}漫画在线免费阅读`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="lg:w-2/3 flex flex-col">
                <span className="whitespace-nowrap px-3 py-1 bg-primary-100 text-primary-700 text-xs rounded-full w-fit">
                  {featuredManga.status}
                </span>
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-4">
                  {featuredManga.title}
                </h2>
                <p className="text-sm text-foreground-500 mt-2">
                  作者：{featuredManga.author}
                </p>
                <div className="flex flex-wrap gap-2 mt-3">
                  {featuredManga.tags.map((tag) => (
                    <span
                      key={tag}
                      className="whitespace-nowrap px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 mt-4 leading-relaxed line-clamp-4">
                  {featuredManga.description}
                </p>
                <div className="flex items-center gap-6 mt-4">
                  <span className="text-sm text-foreground-500">
                    <i className="ri-star-fill text-accent-500 mr-1" />
                    {featuredManga.rating}
                  </span>
                  <span className="text-sm text-foreground-500">
                    <i className="ri-eye-line mr-1" />
                    {featuredManga.views}
                  </span>
                </div>
                <Link
                  to={`/manga/${featuredManga.id}`}
                  className="whitespace-nowrap mt-6 px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors cursor-pointer w-fit"
                >
                  查看详情
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="bg-background-100 py-12 md:py-16" aria-label="漫画分类">
          <div className="w-full px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
              探索更多漫画
            </h2>
            <div className="flex flex-wrap gap-3 justify-center">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={cat.id === 'all' ? '/category' : `/category?type=${cat.id}`}
                  className="whitespace-nowrap flex items-center gap-2 px-4 py-2 bg-background-50 border border-background-200 rounded-full text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  <i className={`${cat.icon} text-base`} />
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Recommended Reading */}
        <section className="bg-background-50 py-14 md:py-20" aria-label="推荐阅读">
          <div className="w-full px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-12">
              热门推荐
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop="">
              {popularMangaList.map((manga) => (
                <Link
                  key={manga.id}
                  to={`/manga/${manga.id}`}
                  className="group cursor-pointer rounded-lg overflow-hidden relative aspect-[3/4]"
                >
                  <img
                    src={manga.coverImage}
                    alt={`${manga.title}漫画`}
                    title={`${manga.title}漫画在线免费阅读 - 古古漫画网`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent flex flex-col justify-end p-5">
                    <h3 className="font-heading text-lg font-bold text-white">
                      {manga.title}
                    </h3>
                    <p className="text-xs text-white/70 mt-1">{manga.author}</p>
                    <div className="flex items-center gap-3 mt-2">
                      <span className="text-xs text-accent-300">
                        <i className="ri-star-fill mr-0.5" />{manga.rating}
                      </span>
                      <span className="text-xs text-white/50">{manga.status}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}